module.exports = __webpack_public_path__ + "static/media/technology.af47cf62.svg";